import styled from "styled-components";

import { NOT_AVAILABLE } from "app/filters/const";
import { abbrNumberFilter, minVisitsFilter, percentageFilter } from "app/filters/ngFilters";

import { ProgressBarContainer } from "./ProgressBarContainer";

const MINIMUM_TRAFFIC_THRESHOLD = 5000;
interface ITrafficShareProps {
    value: any;
    row: any;
    progressBarTooltip?: any;
    hideZeroValue?: boolean;
    innerColor?: string;
    layout?: "row" | "column";
    height?: number;
    fraction?: number;
    thresholdTrafficShareWithVisitsPercentage?: number;
    isPreviousPeriod?: boolean;
    minPercentageToShow?: number;
    undefinedSign?: string;
}

/**
 * Formats the tooltip traffic data
 * just keeping up with the existing logic that TrafficShare
 * component has. it returns a number or boolean.
 * I couldn't change it since it'll break things ¯\_(ツ)_/¯
 */
const resolveVisitsPercentage = (row: FixmeType, progressBarTooltip: FixmeType) => {
    const tooltipTrafficData = row[progressBarTooltip];
    if (tooltipTrafficData) {
        // Encapsulate any data that is bellow 5,000 visits using minVisitsFilter
        // otherwise - abbreviate the number to a displayable format.
        const isBelowMinimumTraffic = tooltipTrafficData < MINIMUM_TRAFFIC_THRESHOLD;
        return isBelowMinimumTraffic ? minVisitsFilter()(tooltipTrafficData) : abbrNumberFilter()(tooltipTrafficData);
    }

    // in case no data is present, return false ¯\_(ツ)_/¯
    return false;
};

/**
 * Overrides progressBar style to remove round borders
 */
const ProgressBarWrapper = styled.div`
    .sw-progress-bar {
        border-radius: 1px;
    }
`;

export const TrafficShare = (props: ITrafficShareProps) => {
    const {
        value,
        row,
        progressBarTooltip,
        innerColor,
        height = 8,
        hideZeroValue = false,
        fraction = 2,
        thresholdTrafficShareWithVisitsPercentage,
        minPercentageToShow = 0.0001,
        undefinedSign = NOT_AVAILABLE,
    } = props;

    const formatDisplayPercentage = (value: number) => {
        if (value <= minPercentageToShow && thresholdTrafficShareWithVisitsPercentage) {
            return `< ${thresholdTrafficShareWithVisitsPercentage}%`;
        } else {
            return shouldHideValue ? undefinedSign : percentageFilter()(value || 0, fraction) + "%";
        }
    };

    const filledBarPercentage = value ? value * 100 : 0;
    const tooltipVisits = resolveVisitsPercentage(row, progressBarTooltip);
    const hasValue = value && typeof value !== "undefined" && value > 0;
    const shouldHideValue = !hasValue && hideZeroValue;

    const valuePercentage = formatDisplayPercentage(value);

    return (
        <ProgressBarWrapper>
            <ProgressBarContainer
                progressBarWidth={filledBarPercentage}
                visits={tooltipVisits}
                valuePercents={valuePercentage}
                innerColor={innerColor}
                height={height}
                layout={props.layout}
                variant={props.isPreviousPeriod ? "secondary" : undefined}
            />
        </ProgressBarWrapper>
    );
};
TrafficShare.displayName = "TrafficShare";
